module.exports = __webpack_public_path__ + "static/img/close.560096e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.png
// module id = JA1j
// module chunks = 1